'use client';

export const ErrorFilled = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M16.0026 30C14.0662 30 12.246 29.6326 10.5422 28.8977C8.83839 28.1628 7.35635 27.1655 6.09611 25.9057C4.83586 24.646 3.83805 23.1646 3.10268 21.4615C2.36756 19.7584 2 17.9388 2 16.0026C2 14.0662 2.36744 12.246 3.10232 10.5422C3.83719 8.83839 4.83451 7.35635 6.09426 6.09611C7.35402 4.83586 8.83544 3.83805 10.5385 3.10268C12.2416 2.36756 14.0612 2 15.9974 2C17.9338 2 19.754 2.36744 21.4578 3.10232C23.1616 3.83719 24.6437 4.83451 25.9039 6.09426C27.1641 7.35402 28.1619 8.83544 28.8973 10.5385C29.6324 12.2416 30 14.0612 30 15.9974C30 17.9338 29.6326 19.754 28.8977 21.4578C28.1628 23.1616 27.1655 24.6437 25.9057 25.9039C24.646 27.1641 23.1646 28.1619 21.4615 28.8973C19.7584 29.6324 17.9388 30 16.0026 30Z"
				fill="#E22339"
			/>
			<path
				d="M14.931 7.43051C15.218 7.14318 15.5742 6.99951 15.9995 6.99951C16.4245 6.99951 16.7808 7.14318 17.0685 7.43051C17.3562 7.71818 17.5 8.07451 17.5 8.49951L17.4995 16.5C17.4995 16.925 17.3558 17.2812 17.0685 17.5685C16.7815 17.8562 16.4253 18 16 18C15.575 18 15.2187 17.8562 14.931 17.5685C14.6433 17.2812 14.4995 16.925 14.4995 16.5L14.5 8.49951C14.5 8.07451 14.6437 7.71818 14.931 7.43051Z"
				fill="white"
			/>
			<path
				d="M16 21.5006C15.5042 21.5006 15.0886 21.6683 14.7532 22.0037C14.4177 22.3392 14.25 22.7548 14.25 23.2505C14.25 23.7463 14.4177 24.1619 14.7532 24.4974C15.0886 24.8325 15.5042 25 16 25C16.4958 25 16.9114 24.8325 17.2468 24.4974C17.5823 24.1619 17.75 23.7463 17.75 23.2505C17.75 22.7548 17.5823 22.3392 17.2468 22.0037C16.9114 21.6683 16.4958 21.5006 16 21.5006Z"
				fill="white"
			/>
		</svg>
	);
};
